<app-customer-conditions [canAutoSave]="false" [showDefaultConditions]="showDefaultConditions"
  [useDefaultConditions]="useDefaultConditions">
</app-customer-conditions>
